<template>
  <div class="el-pagination1">
    <div class="fl">
      <slot></slot>
    </div>
    <div class="fr">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :total="total"
        :layout="layout"
        :page-size="pageSize"
        :current-page.sync="page"
        :pager-count="pageCount"
        :small="small"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'elPagination1',
  props: {
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next'
    },
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageCount: {
      type: Number,
      default: 7
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    page: {
      get() {
        return this.currentPage
      },
      set(val) {}
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('handleSizeChange', val)
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val)
    }
  }
}
</script>

<style lang="scss">
.el-pagination1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text-yellow {
    color: #df5813 !important;
  }
}
</style>
